"use client";

import { Button } from "@/components";
import { Swiper, SwiperSlide } from "swiper/react";
import { getImageURL, useSwiperSliderOptions } from "@/lib";
import { Navigation } from "swiper/modules";

export const HomePageProductCategory = ({
  data = {},
  slug = "product_categories",
}) => {
  const { heading = "", list = [], description, parent_class } = data;

  const {
    nextSlide,
    prevSlide,
    sliderButtons: { hasNext, hasPrev },
    options: imagesSliderOptions,
  } = useSwiperSliderOptions({
    modules: [Navigation],
    clickable: "true",
    slidesPerView: 2,
    spaceBetween: 16,

    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 1,
      },
      992: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 2,
      },
    },
  });

  if (!Array.isArray(list) || list.length === 0) {
    return null;
  }

  const [firstItem, ...sliderItems] = list;

  return (
    <>
      <section className={`pcat__section ${parent_class || ""}`}>
        <div className="section_overlay"></div>
        <div className="custom-container">
          <div className="row">
            <div className="col-12 col-xl-12">
              <div className="section_header">
                <h3
                  className="heading text-center fs-48 fw-300"
                  dangerouslySetInnerHTML={{
                    __html: heading,
                  }}
                />

                <div className="content__wrap text-center">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: description,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6">
              {firstItem && (
                <div className="lg__product_wrapper d-flex">
                  <div className="lg__product">
                    <div className="col_header">
                      <h3
                        className="heading fs-36 fw-500"
                        dangerouslySetInnerHTML={{
                          __html: firstItem?.name,
                        }}
                      />
                    </div>
                    <div className="content__wrap">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: firstItem?.description,
                        }}
                      />
                    </div>
                    <div className="btn-group">
                      <Button
                        label={firstItem.cta?.title}
                        href={firstItem.cta?.url || "#"}
                        target={
                          firstItem.cta?.open_new_tab === "yes"
                            ? "_blank"
                            : undefined
                        }
                      />
                    </div>
                  </div>
                  <div className="lg__product_img">
                    <div className="img__wrapper">
                      <img
                        className="img-fluid"
                        src={getImageURL(firstItem.image?.src)}
                        alt={firstItem.image?.alt || firstItem.name}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="col-12 col-md-6">
              {sliderItems.length > 0 &&
                sliderItems.map((item, index) => (
                  <div key={index} className="lg__product_wrapper d-flex">
                    <div className="lg__product">
                      <div className="col_header">
                        <h3
                          className="heading fs-36 fw-500"
                          dangerouslySetInnerHTML={{
                            __html: item?.name,
                          }}
                        />
                      </div>
                      <div className="content__wrap">
                        <p
                          dangerouslySetInnerHTML={{
                            __html: item?.description,
                          }}
                        />
                      </div>
                      <div className="btn-group">
                        <Button
                          label={item.cta?.title}
                          href={item.cta?.url || "#"}
                          target={
                            item.cta?.open_new_tab === "yes"
                              ? "_blank"
                              : undefined
                          }
                        />
                      </div>
                    </div>
                    <div className="lg__product_img">
                      <div className="img__wrapper">
                        <img
                          className="img-fluid"
                          src={getImageURL(item.image?.src)}
                          alt={item.image?.alt || item.name}
                        />
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
